import {Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';

import {HttpService} from '../http.service';
import {SearchOptionsRequest} from '../../shared/models/SearchOptionsRequest.model';
import {UserPermissionDto} from '../../permission/classes/userPermissionDto.models';
import {GpHoldingListItemReqRes} from '../../dashboard/shared/holding/GpHoldingListItem.model';
import {SearchOptionsResponse} from '../../shared/models/SearchOptionsResponse.model';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionDataService {
  constructor(private http: HttpService) {
  }

  protected readonly baseEndpoint = 'permissions';
  private readonly ACCOUNT_ENDPOINT = 'account';

  protected getSearchOptionsToQuerystring(options: SearchOptionsRequest): string {
    const filter = encodeURIComponent(options.filter);
    return `?filter=${filter}&sortOrder=${options.sortOrder}&orderBy=${options.orderBy}&pageNumber=${options.pageNumber}&pageSize=${options.pageSize}`;
  }

  getPermissionsList(options: SearchOptionsRequest = null): Observable<UserPermissionDto[]> {
    let queryString = '';
    if (options != null) {
      options.pageSize = 1000;
      options.pageNumber = 0;
      queryString = `?sortOrder=${options.sortOrder}&orderBy=${options.orderBy}&pageNumber=${options.pageNumber}&pageSize=${options.pageSize}`;
    }
    return this.http.getTyped<UserPermissionDto[]>(this.baseEndpoint + queryString).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  isAllContactsVisible(): Observable<boolean> {
    return this.http.getTyped<boolean>(`${this.baseEndpoint}/isallcontactsvisible`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  updateUserPermission(model: UserPermissionDto): Observable<any> {
    return this.http.putTyped<UserPermissionDto>(this.baseEndpoint, model);
  }

  deleteUserPermission(model: UserPermissionDto): Observable<UserPermissionDto> {
    return this.http.putTyped<UserPermissionDto>(`${this.ACCOUNT_ENDPOINT}/${model.clientId}/remove-team-member`, model);
  }

  getById(userPermissionId: number): Observable<UserPermissionDto> {
    return this.http.getTyped<UserPermissionDto>(`${this.baseEndpoint}/${userPermissionId}`);
  }

  getAllHoldings(): Observable<SearchOptionsResponse<GpHoldingListItemReqRes>> {
    return this.http.getTyped<SearchOptionsResponse<GpHoldingListItemReqRes>>(`${this.baseEndpoint}/holdings`);
  }
}
